<template>
  <section
    v-if="data"
    :class="sectionClass"
    class="w-full overflow-hidden"
  >
    <UiHeading
      v-if="data?.heading"
      :pin="data?.heading?.pin"
      :title="data?.heading?.title"
      :description="data?.heading?.description"
      :button="data?.heading?.button"
      :color="data?.heading?.color"
      :position="data?.heading?.position"
      v-aos="animate && 'zoom-out'"
    />
    <div
      v-aos="animate && 'fade-up'"
      :class="data?.containerFull ? 'w-full' : 'container'"
    >
      <div class="w-full flex justify-center">
        <PluginsToggle
          :tabs="data?.items"
          class="w-full lg:w-[900px]"
          :color="data?.heading?.color"
        />
      </div>
    </div>
  </section>
</template>
<script setup>
import { computed } from "vue";
import { sectionOuterSpacingClass } from "~/composables/sectionSpacing";

const props = defineProps({
  data: {
    type: Object,
  },
  animate: { type: Boolean, default: false },
});

const sectionClass = computed(() => {
  let bg = '';
  const bgColor = props.data?.backgroundColor;
  if (bgColor === 'first') bg = 'bg-brand-first' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'second') bg = 'bg-brand-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'third') bg = 'bg-brand-third' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'dark-first') bg = 'bg-brand-dark' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'dark-second') bg = 'bg-brand-dark-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'light-first') bg = 'bg-brand-light' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'light-second') bg = 'bg-brand-light-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  return [bg, sectionOuterSpacingClass(props.data)];
});
</script>
